import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface AthleticNetJobStatusResponse {
    status: string;
    message: string;
    event_count?: number;
    new_count?: number;
    duplicate_count?: number;
    athlete_name?: string;
    error?: string;
}

type ReturnType = Promise<AxiosResponse<AthleticNetJobStatusResponse>>;

const getAthleticNetJobStatus = (jobId: string): ReturnType => {
    return Request.get(`/workouts/track-events/athletic-net-job/${jobId}`);
};

export default getAthleticNetJobStatus;
